import React, { ReactNode, useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { XLg } from 'react-bootstrap-icons'
import { ContentView } from '../../ContentView';

export const Preview: React.FC<{ data: any, children: ReactNode }> = ({ data, children }) => {

    const [mostrar, setMostrar] = useState(false)

    return <>
        <span onClick={() => setMostrar(true)}>{children}</span>
        <Modal show={mostrar} backdrop="static" onHide={() => { setMostrar(false) }} centered size="lg" fullscreen={"sm-down"}>
            <Modal.Header closeButton>Vista Previa</Modal.Header>
            <Modal.Body>
                <ContentView content={data}/>
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" variant="danger" onClick={() => setMostrar(false)}><XLg /> Cancelar</Button>
            </Modal.Footer>
        </Modal>
    </>
}